export default "__VITE_ASSET__CLh0xApm__"